import Skeleton from '@mui/material/Skeleton'
import React from 'react'

const CkeckboxRolesSkeleton = ({ length = 7 }) => {
  return <>
    { Array.from({ length }).map((_, index) => (
      <div key={`skeleton-loading-${index}`} className='flex gap-4 items-center'>
        <Skeleton variant="rectangular" width={20} height={20} />
        <Skeleton variant='text' width='80px' height={30} />
      </div>
    ))}
  </>;
}

export default CkeckboxRolesSkeleton